import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {currentPlan} from './inner-component.model';
import {AppConfigService} from '../../common/service/app-config.service';

@Injectable({
    providedIn: 'root'
})
export class NlrpInnerComponentService {
    private currentPlansData = new BehaviorSubject<currentPlan[]>([]);
    private paginatedCurrentPlansData = new BehaviorSubject<currentPlan[]>([]);

    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    getMyPlans(): Observable<currentPlan[]> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/plans/lodgement/myPlans';
        return this.http.get<currentPlan[]>(url);
    }

    getOrganisationPlans(): Observable<currentPlan[]> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/plans/lodgement/organisationPlans';
        return this.http.get<currentPlan[]>(url);
    }

    updateCurrentPlansData(newdata: currentPlan[]) {
        this.currentPlansData.next(newdata);
    }

    getCurrentPlansData(): Observable<currentPlan[]> {
        return this.currentPlansData;
    }

    updatePaginatedCurrentPlansData(newdata: currentPlan[]) {
        this.paginatedCurrentPlansData.next(newdata);
    }

    getPaginatedCurrentPlansData(): Observable<currentPlan[]> {
        return this.paginatedCurrentPlansData;
    }
}
